import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '@app/shared/modules/icons/icon.module';
import { LegalTermsComponent } from './containers/legal-terms.component';
import { LegalTermsRoutingModule } from './legal-terms-routing.module';
import { LogoModule } from '@app/shared/modules/logo/logo.module';
import { TableOfContentsModule } from '@app/modules/ui/table-of-contents/table-of-contents.module';
import { TabsModule } from '@app/modules/ui/tabs/tabs.module';
import { TranslateModule } from '@app/shared/modules/translate/translate.module';
import { UIRouterModule } from '@uirouter/angular';

@NgModule({
  imports: [
    CommonModule,
    IconsModule,
    LegalTermsRoutingModule,
    LogoModule,
    TableOfContentsModule,
    TabsModule,
    TranslateModule,
    UIRouterModule
  ],
  declarations: [LegalTermsComponent]
})
export class LegalTermsModule {}
